/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Valve_Uid_UniqueInputs */



/**
* | output |
* | --- |
* | "The thermostatic head uid must be unique" |
*
* @param {Valve_Uid_UniqueInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const valve_uid_unique = /** @type {((inputs?: Valve_Uid_UniqueInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Valve_Uid_UniqueInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("The thermostatic head uid must be unique")
	return /** @type {LocalizedString} */ ("Le uid de la tête thermostatique doit être unique")
});